import { useQueryClient } from '@tanstack/react-query';
import { Select } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { updateProfile } from '../../fetchHooks/updateProfile';
import styles from './FontSelector.module.css';

interface FontSelectorProps {
  userId?: number;
  currentFont?: string;
  currentSettings?: Record<string, any>;
}

const FontSelector = ({ userId, currentFont, currentSettings = {} }: FontSelectorProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [selectedFont, setSelectedFont] = useState(currentFont || 'default');
  const [isLoading, setIsLoading] = useState(false);

  const fontOptions = [
    { value: 'default', label: t('profile.fonts.default', 'Default (Georgia)') },
    { value: 'fixedsys', label: t('profile.fonts.fixedsys', 'Fixedsys') },
    { value: 'alexfont', label: t('profile.fonts.alexfont', 'Alexfont') },
  ];

  const handleFontChange = (value: string) => {
    setSelectedFont(value);
    setIsLoading(true);

    updateProfile(
      {
        id: userId,
        settings: {
          ...currentSettings,
          preferredFont: value,
        },
      },
      () => {
        setIsLoading(false);
        queryClient.invalidateQueries({ queryKey: ['userProfile'] });
      },
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.label}>{t('profile.preferredFont', 'Preferred Font')}</div>
      <Select
        value={selectedFont}
        onChange={handleFontChange}
        options={fontOptions}
        loading={isLoading}
        className={styles.select}
      />
      <div className={styles.description}>
        {t('profile.fontDescription', 'This font will be used in your notes and diary entries')}
      </div>
    </div>
  );
};

export default FontSelector;
